/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/ban-types */

import React from 'react';
import clsx from 'clsx';

// components
import Link from 'next/link';

// utils
import Button, { ButtonProps } from '@/components/elements/Button';

// icons
import { Wallet as WalletIcon } from '../icons';

export type ConnectWalletRedirectButtonProps = Omit<
  ButtonProps,
  'ref' | 'children'
>;

/**
 * @component ConnectWalletRedirectButton
 */
function ConnectWalletRedirectButton({
  className,
  ...rest
}: ConnectWalletRedirectButtonProps) {
  const rootClasses = clsx(className);
  return (
    <Link href="/connect/?type=wallet">
      <Button
        color="primary"
        className={rootClasses}
        startIcon={<WalletIcon />}
        {...rest}
      >
        Connect Wallet
      </Button>
    </Link>
  );
}

export default ConnectWalletRedirectButton;
